import Vue from 'vue'
import Vuex from 'vuex'
import form from './modules/form'
import signupform from './modules/signup-form'
import anniversary from './modules/anniversary'
import advancedform from './modules/advanced-form'
import extendedform from './modules/extended-form'
import advancedonlineform from './modules/advanced-online-form'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url: '',
    locale: 'de',
    formtype: null
  },
  mutations: {
    url (state, url) {
      state.url = url
    },
    locale (state, locale) {
      state.locale = locale
    },
    formtype (state, formtype) {
      state.formtype = formtype
    }
  },
  actions: {

  },
  modules: {
    form,
    signupform,
    anniversary,
    advancedform,
    extendedform,
    advancedonlineform
  }
})

//  Upload file

var inputs = document.querySelectorAll('.inputfile')
Array.prototype.forEach.call(inputs, function (input) {
  var label = input.nextElementSibling
  var labelVal = label.innerHTML

  input.addEventListener('change', function (e) {
    console.log('change')
    var fileName = ''
    if (this.files && this.files.length > 1) {
      fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length)
    } else {
      fileName = e.target.files[0].name
    }

    if (fileName) {
      label.querySelector('span').innerHTML = fileName
    } else {
      label.innerHTML = labelVal
    }
  })
})
